/**
 * Clickable blocks - entire block will be clickable
 * Styles are in _helpers.scss under .block--linked
 *
 * Usage:
 * {{#link}} data-clickable="{{link_path}}"{{/link}}
 * {{#url}} data-clickable="{{href}}"{{/url}}
 */
(function($) {
  Drupal.behaviors.clickable = {
    eventLabel: '',
    attach: function(context) {
      var self = this;
      var $theClickables = $('[data-clickable!=""][data-clickable]', context);
      $theClickables.each(function() {
        var $clickable = $(this);
        var disableClick = false;

        if ($clickable.parents('.js-carousel-slide').length) {
          $clickable.on('mousedown', function() {
            disableClick = false;
          }).on('mousemove', function() {
            disableClick = true;
          });
        }
        $clickable.once('clickable' + self.eventLabel).addClass('block--linked').on('click', function(e) {
          if ($(e.target).closest('.js-play-button-icon').length > 0 || $(e.target).closest('.js-elc-button').length > 0 || $(e.target).closest('.js-product-grid').length > 0 || disableClick) {
            return;
          }

          const target = $(this).data('clickable');

          // Fix for hitchhiking hashes
          if (window.location.hash) {
            history.replaceState('', '', target);
          }

          // If inside an iframe, redirect the parent window
          if (window.self !== window.top) {
            try {
              window.top.location.href = target;
            // eslint-disable-next-line no-unused-vars
            } catch (err) {
              window.location.href = target;
            }
          } else {
            window.location.href = target;
          }
        });
      });

      // Re-attach event after Carousel Initialized
      $(document).on('contentFormatterSlickInitialized', function (e, carousel) {
        var $clickableCarouselItems = $(carousel).find('[data-clickable!=""][data-clickable]');

        if ($clickableCarouselItems.length > 0) {
          self.eventLabel = 'carousel';
          self.attach($(carousel));
        }
      });
    }
  };
})(jQuery);
